var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFullScreen)?_c('ControlButton',{attrs:{"iconClass":"sr-2 sr-v2-collapse"},on:{"click":function($event){return _vm.setFullScreen(false)}}}):_c('ControlButton',{attrs:{"iconClass":"sr-2 sr-v2-expand"},on:{"click":function($event){return _vm.reallySetFullScreen()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }